module.exports = __webpack_public_path__ + "img/img_ug1.b12e7235.jpg";